import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: localStorage
})

// function roleExists (userRoles, role) {
//   return userRoles.some(function (el) {
//     return el.description === role
//   })
// }

export default new Vuex.Store({
  strict: false,
  state: {
    currentYear: 0,
    token: null,
    user: null,
    controls: null,
    isUserLoggedIn: false,
    isAdmin: false,
    passwordReset: false,
    currentPage: 'RIDE',
    logo: null
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      if (token) {
        state.isUserLoggedIn = true
      } else {
        state.isUserLoggedIn = false
      }
    },
    setUser (state, user) {
      state.user = user
      if (user && user.Role.role === 'Admin') {
        state.isAdmin = true
        // state.isAdmin = roleExists(user.Role.role, 'Administrator')
      } else {
        state.isAdmin = false
      }
    },
    setMini (state, mini) {
      state.user.mini = mini
    },
    setCurrentYear (state, year) {
      state.currentYear = year
    },
    setControl (state, controls) {
      state.controls = controls
    },
    setCurrentPage (state, page) {
      state.currentPage = page
    },
    setLogo (state, logo) {
      state.logo = logo
    }
  },
  actions: {
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },
    setMini ({commit}, mini) {
      commit('setMini', mini)
    },
    setCurrentYear ({commit}, year) {
      commit('setCurrentYear', year)
    },
    setControl ({commit}, controls) {
      commit('setControl', controls)
    },
    setCurrentPage ({commit}, page) {
      commit('setCurrentPage', page)
    },
    setLogo ({commit}, logo) {
      commit('setLogo', logo)
    }
  },
  plugins: [vuexLocalStorage.plugin]
})



// WEBPACK FOOTER //
// ./src/store/store.js